import VideoEmbedToolbarView from "./VideoEmbedToolbarView.vue";
import VideoEmbedNode from "./VideoEmbedNode";
import {isActive} from "@tiptap/vue-3";
import VideoEmbedBubbleView from "./VideoEmbedBubbleView.vue";

export default class VideoEmbed {

    constructor() {
        this.toolbarView = VideoEmbedToolbarView;
        this.bubbleView = VideoEmbedBubbleView;
    }

    showBubble(props) {
        return isActive(props.state, "videoEmbed");
    }

    static create() {
        return new VideoEmbed();
    }

    getExtensions() {
        return [VideoEmbedNode];
    }
}